/* eslint-disable no-useless-escape */
angular.module('tgaApp').directive('autofocus', ['$timeout', 'utilityService',
  function ($timeout, utilityService) {
    return {
      restrict: 'A',
      link: ($scope, $element) => {
        $timeout(
          () => {
            if (!utilityService.isMobile()) {
              $element[0].focus();
            } else {
              $element[0].blur();
            }
          },
        );
      },
    };
  },
]);
